import { useEffect, useState } from 'react';
import { useAccountPersistentStore } from '../../../modules/store/accountPersistentStore';

// Using the persist API directly to check if the store has hydrated, since the store itself may not be initialized yet when this hook is called.
export const useHasAccountPersistentStoreHydrated = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    if (useAccountPersistentStore.persist?.hasHydrated?.()) {
      setHydrated(true);
      return;
    }

    const unsubFinishHydration = useAccountPersistentStore.persist?.onFinishHydration?.(() => {
      setHydrated(true);
    });

    return () => {
      unsubFinishHydration?.();
    };
  }, []);

  return hydrated;
};
